import { loadStripe, Stripe, StripeError } from "@stripe/stripe-js";

export const STRIPE_LOAD_ERROR = "We couldn't load the secure payment form. Please disable any ad blocker or privacy tool for this page, then try again.";

let stripePromise: Promise<Stripe | null> | null = null;

export async function handleStripeErrors<T extends { error?: StripeError }>(stripeCall: () => Promise<T>) {
    const { error, ...rest } = await stripeCall();
    if (error) {
        throw new Error(error.message);
    }
    return rest;
}

export async function getStripe() {
    if (!stripePromise) {
        stripePromise = (async () => {
            const key = (window as any).stripePublishableKey;

            if (!key) {
                return null;
            }

            const stripe = await loadStripe(key);
            if (!stripe) {
                stripePromise = null;
                throw new Error(STRIPE_LOAD_ERROR);
            }
            return stripe;
        })();
    }

    return await stripePromise;
}
